import Button from '@/components/atoms/button';

type PaginationProps = {
  label: string;
  loading: boolean;
  onLoadMore: () => void;
};

export function Pagination({ label, loading, onLoadMore }: PaginationProps) {
  return (
    <Button
      onClick={() => onLoadMore()}
      disabled={loading}
      variant='outlined'
      color='secondary'
      fullwidth
    >
      {loading ? 'Loading...' : label}
    </Button>
  );
}
